export enum UserRightType {
	NO_PERMISSION = 'noPermission',
	READ_ONLY = 'readOnly',
	WRITE = 'write',
}
